import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Selector de idioma del PORTAL PARTNER. Vive aparte de `LanguageSelector`
// (el del portal admin, con icono de globo) porque aquí lo comparten el navbar
// del portal y la landing PÚBLICA del programa, que no tiene navbar: la
// variante `onHero` lo pinta en blanco para que se lea sobre el degradado.

interface PartnerLanguageSelectorProps {
  /** Variante para fondos oscuros (el hero de la landing del programa). */
  onHero?: boolean;
}

/**
 * Idioma que representa el selector. El detector puede devolver 'es-ES' o
 * 'en-GB', y el Select solo conoce 'es' y 'en': sin normalizar saldría vacío
 * (y MUI avisaría de un `value` fuera de rango).
 */
export const partnerUiLanguage = (language?: string): string =>
  (language || 'es').toLowerCase().startsWith('es') ? 'es' : 'en';

const PartnerLanguageSelector: React.FC<PartnerLanguageSelectorProps> = ({ onHero = false }) => {
  const { t, i18n } = useTranslation();

  const handleChange = (event: any) => {
    const newLang = event.target.value as string;
    i18n.changeLanguage(newLang);
    // Clave heredada del portal cliente (el detector persiste en 'i18nextLng').
    localStorage.setItem('language', newLang);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 88 }}>
      <Select
        value={partnerUiLanguage(i18n.resolvedLanguage || i18n.language)}
        onChange={handleChange}
        inputProps={{ 'aria-label': t('partner.nav.language', 'Idioma') }}
        sx={{
          '& .MuiSelect-select': { py: 0.5, fontSize: '0.875rem' },
          ...(onHero
            ? {
                color: '#fff',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.55)' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
                '& .MuiSvgIcon-root': { color: '#fff' }
              }
            : {})
        }}
      >
        <MenuItem value="es">🇪🇸 ES</MenuItem>
        <MenuItem value="en">🇬🇧 EN</MenuItem>
      </Select>
    </FormControl>
  );
};

export default PartnerLanguageSelector;
